module.exports = __webpack_public_path__ + "img/lang-id.9d7726a5.svg";